/*=========================================================================================
  File Name: moduleAuthGetters.js
  Description: Auth Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  currentUserImage: state => state.currentUserImage,
  myBranches : state => state.myBranches,
  currentBranch : state => state.currentBranch,
  currentPackage : state => state.currentPackage,
  permission: state => state.permission,
}
